import SmartBlock from './SmartBlock.vue';

export default SmartBlock;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/smart/index.ts